(function ($) {

        $(document).ready(function () {

            if ($('.img-slider').length > 0) {
                setTimeout(function () {
                    $(".img-slider .row-wrap").css({"opacity": "1"});
                }, 500);

                $('.img-slider .row-wrap').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: false,
                    cssEase: 'linear',
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                draggable: true
                            }
                        }
                    ]
                });
            }

        });

})(jQuery);